var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "16px",
    viewBox: "0 0 23 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UIKit",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-682.000000, -1365.000000)",
    fill: "#A5BFCE",
    fillRule: "nonzero",
    id: "box"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M704.93898,1368.99332 C705.100689,1369.32189 704.928207,1369.71473 704.572434,1369.81471 L702.700222,1370.34685 L702.700222,1377.89293 C702.700222,1378.41432 702.340869,1378.87147 701.830582,1379.00002 L694.054217,1380.93207 C693.565477,1381.0535 693.155836,1380.98563 692.940225,1380.93207 L685.171019,1379.00002 C684.660732,1378.87503 684.30138,1378.41791 684.30138,1377.89293 L684.30138,1370.34685 L682.425553,1369.81471 C682.073395,1369.71473 681.897298,1369.32189 682.062621,1368.99332 L683.913286,1365.32207 C684.057027,1365.03636 684.344509,1364.9828 684.509797,1365.00421 L693.500801,1366.14346 L702.48819,1365.00421 C702.653513,1364.9828 702.944574,1365.03636 703.088315,1365.32207 L704.93898,1368.99332 Z M685.091955,1366.8077 L684.215121,1368.54336 L689.174184,1369.95042 L690.654723,1367.51125 L685.091955,1366.8077 Z M686.026271,1370.83612 L686.026271,1377.44652 L692.638355,1379.0893 L692.638355,1367.56482 L690.205532,1371.57178 C690.086953,1371.7682 689.828212,1371.91461 689.54073,1371.83248 L686.026271,1370.83612 Z M700.97533,1377.44652 L700.97533,1370.83967 L697.460871,1371.83607 C697.176969,1371.9182 696.914648,1371.77176 696.796069,1371.57534 L694.363246,1367.56482 L694.363246,1379.0893 L700.97533,1377.44652 Z M697.823803,1369.95042 L702.782866,1368.54336 L701.909646,1366.8077 L696.343264,1367.51125 L697.823803,1369.95042 Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.3c3c7441.svg";
export { ForwardRef as ReactComponent };